<template>
   <div>
      <Header ref="header" title="改签" :showBack="true"></Header>
      <div class="ticketchange-wrap">
         <div class="ticketInfo-wrap module-wrap">
            <p class="wrap-title">当前班次：</p>
            <div class="ticketInfo module-card">
               <div class="ticketInfo-row max-wrap">
                  <div class="classTime-wrap">
                     <p class="classTime">{{ changeTicket.ClassTime }}</p>
                  </div>
                  <div class="line-wrap">
                     <p class="lineName">{{ changeTicket.LineName }}</p>
                  </div>
               </div>
               <div class="ticketInfo-row">
                  <div class="classTime-wrap"></div>
                  <div class="custInfo-wrap">
                     <div class="custInfo">
                        <p>{{ changeTicket.StartNodeName }} - {{ changeTicket.ArrivalNodeName }}</p>
                        <p>{{ changeTicket.CustName }}({{ changeTicket.ticketTypeName }})</p>
                     </div>
                     <div class="seat-wrap">
                        <p class="seatNo">{{ changeTicket.SeatNo }}</p>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div class="changeMode-wrap module-wrap">
            <p class="wrap-title">改签模式：</p>
            <div class="module-card">
               <van-tabs v-model="activeTab" color="#ff7445" title-active-color="#ff7920" line-width="60px"
                  @change="onTabsChange">
                  <van-tab title="同站点改班次">
                     <div class="tab-content">
                        <DateSelect :ClassDate.sync="classDate" @onGoBefore="onClassDateChange"
                           @onGoAfter="onClassDateChange" :minDate="classMinDate"></DateSelect>
                        <LineClassDayList :list="classTimeList" @itemClick="onClassItemClick"
                           @refrashList="onRefrashClassList"></LineClassDayList>
                     </div>
                  </van-tab>
                  <van-tab title="同班次改站点">
                     <div class="tab-content">
                        <p class="wrap-title"><b>选择上车点：</b></p>
                        <van-radio-group v-model="startNodeGID">
                           <van-radio :name="item.NodeGID" v-for="(item, index) in startNodeList" :key="index"
                              class="node-radio">
                              {{ item.NodeName }}
                           </van-radio>
                        </van-radio-group>
                        <p class="wrap-title"><b>选择下车点：</b></p>
                        <van-radio-group v-model="arrivalNodeGID">
                           <van-radio :name="item.NodeGID" v-for="(item, index) in arrivalNodeList" :key="index"
                              class="node-radio">
                              {{ item.NodeName }}
                           </van-radio>
                        </van-radio-group>
                     </div>
                  </van-tab>
                  <van-tab title="改线路">
                     <div class="tab-content">
                        <router-view></router-view>
                     </div>
                  </van-tab>
               </van-tabs>
            </div>
         </div>
         <div class="module-wrap">
            <van-button color="#ff9900" block :disabled="btnDisabled" @click="confirmTicketChange">确定改签</van-button>
         </div>
      </div>
   </div>
</template>

<script>
import ticketChangeStore from "@/stores/ticketChangeStore";
import DateSelect from "@/components/Common/DateSelect.vue";
import LineClassDayList from "@/components/LineClassDay/LineClassDayList.vue";
import Header from "@/components/Header/Header.vue";
export default {
   components: {
      Header,
      DateSelect,
      LineClassDayList
   },
   data() {
      const now = new Date();
      const classDate = new Date(this.$moment(new Date()).format('YYYY-MM-DD'));
      return {
         activeTab: 0,
         changeTicket: JSON.parse(window.localStorage.getItem('changeTicket')),
         operObj: JSON.parse(window.localStorage.getItem("adminInfo")), // 操作员 对象

         // 同站点改班次
         classTimeList: [],
         classDate: classDate,
         classMinDate: classDate,

         // 同班次改站点
         startNodeGID: '',
         startNodeList: [],
         arrivalNodeGID: '',
         arrivalNodeList: []
      }
   },
   computed: {
      lineClassDayGID() {
         return ticketChangeStore.getters.getLineClassDayGID;
      },
      btnDisabled() {
         let result = true;
         switch (this.activeTab) {
            case 0:
               result = this.lineClassDayGID ? false : true;
               break;
            case 1:
               result = this.lineClassDayGID && this.startNodeGID && this.arrivalNodeGID ? false : true;
               break;
            case 2:

               break;
         }
         return result;
      }
   },
   methods: {
      onTabsChange(index) {
         // 切换选项卡清空所选的gid
         if (index == 0 || index == 1) {
            if (this.$route.path != '/TicketChange') {
               this.$router.replace({
                  path: "/TicketChange",
               });
            }
         }
         // 清空选择的站点
         this.startNodeGID = '';
         this.arrivalNodeGID = '';
         switch (index) {
            case 0:
               this.getLineClassDaySaleQuery();
               break;
            case 1:
               ticketChangeStore.dispatch('getNewLineClassDayGID', this.changeTicket.LineClassDayGID);
               this.getStartNodeList();
               this.getArrivalNodeList();
               break;
            case 2:
               this.$router.replace({
                  path: "/TicketChange/LineClass",
               });
               break;
         }
      },

      // 获取售票信息
      async getLineClassDaySaleQuery() {
         // 清除选中状态
         ticketChangeStore.dispatch('getNewLineClassDayGID', null);
         const AgentAppID = this.$utils.getSysParams("WindowSaleAgentAppID");
         const classDate = this.$moment(this.classDate).format('YYYY-MM-DD');
         let params = {
            AgentAppID,
            StartNodeGID: this.changeTicket.StartNodeGID,
            ArrivalNodeGID: this.changeTicket.ArrivalNodeGID,
            ClassDate: classDate,
            OperGID: this.operObj.GID,
         };
         let classTimeList = [];
         // 获取可售班次
         const classDaySaleRes = await this.$http
            .post(this.$api.getLineClassDaySaleQuery, this.$qs.stringify(params));
         classTimeList = classDaySaleRes.data;
         if (classTimeList.length > 0) {
            // 获取班次的检票数/售票数
            const lineGIDList = Array.from(new Set(classTimeList.map(c => c.LineGID))).join(',');
            const classDayRes = await this.$http
               .post(this.$api.getLineClassDay, {
                  LineGIDList: lineGIDList,
                  OrganizationGID: this.operObj.OrganizationGID,
                  BeginDate: classDate,
                  EndDate: classDate,
                  CompGID: this.operObj.CompGID,
               });
            classTimeList.forEach(i => {
               let classTime = classDayRes.data.find(c => c.GID == i.GID);
               if (classTime) {
                  i.LicensePlateNumberList = classTime.LicensePlateNumberList;
                  i.CheckedCount = classTime.CheckedCount;
                  i.HandSellCount = classTime.HandSellCount;
               }
            });
         }
         this.classTimeList = classTimeList;
      },

      // 获取上车点
      getStartNodeList() {
         this.$http.post(this.$api.getStartNode, {
            LineClassDayGID: this.lineClassDayGID
         }).then(res => {
            this.startNodeList = res.data;
         })
      },

      // 获取下车点
      getArrivalNodeList() {
         this.$http.post(this.$api.getArrivalNode, {
            LineClassDayGID: this.lineClassDayGID
         }).then(res => {
            this.arrivalNodeList = res.data;
         })
      },

      // 选中班次信息
      onClassItemClick(item) {
         ticketChangeStore.dispatch('getNewLineClassDayGID', item.GID);
      },

      // 修改日期
      onClassDateChange(date) {
         this.classDate = date;
         this.getLineClassDaySaleQuery();
      },

      // 刷新班次列表
      onRefrashClassList() {
         this.getLineClassDaySaleQuery();
      },

      // 确认改乘
      confirmTicketChange() {
         let commitParam = {
            LineClassDayGID: this.lineClassDayGID,
            StartNodeGID: '',
            ArrivalNodeGID: '',
            ChangeOrderDetailGIDList: this.changeTicket.OrderDetailGID,
            OperGID: this.operObj.GID, //操作员GID
            OperCode: this.operObj.UserCode, //操作员代码
            OperName: this.operObj.UserName, //操作员名称
         };
         switch (this.activeTab) {
            case 0:
               commitParam.StartNodeGID = this.changeTicket.StartNodeGID;
               commitParam.ArrivalNodeGID = this.changeTicket.ArrivalNodeGID;
               break;
            case 1:
               commitParam.StartNodeGID = this.startNodeGID;
               commitParam.ArrivalNodeGID = this.arrivalNodeGID;
               break;
            case 2:

               break;
         }

         //改乘
         this.$http
            .post(
               this.$api.TicketDetailChangeLineClass,
               this.$qs.stringify(commitParam)
            )
            .then((res) => {
               if (res.success) {
                  this.$toast("改乘成功");
                  window.localStorage.removeItem('changeTicket');
                  //1s后返回检票列表
                  setTimeout(() => {
                     // this.$router.replace({
                     //    path: "TicketCheck",
                     // });
                     this.$router.back(-1);
                  }, 1000);
               } else {
                  this.$dialog.alert({
                     title: "提示",
                     message: res.msg,
                  });
               }
            });
      }
   },
   created() {
      this.onTabsChange(this.activeTab);
   },
   destroyed() {
      // debugger
      // window.localStorage.removeItem('changeTicket');
   }
}
</script>

<style lang="less" scoped>
/deep/ .LineClassDaySale {
   background: #f1f1f1;

   .btn {
      position: relative !important;
   }
}

/deep/ .LineClassDaySaleQuery {
   .date-content {
      position: unset !important;
   }

   .lineClassDay-wrapper {
      margin-top: .8rem;
   }

   .wrapper {
      position: unset !important;
   }

   .none{
      margin-top: 1.333rem;
   }
}
</style>
<style lang="less" scoped>
.ticketchange-wrap {
   padding: .267rem;
   font-size: .373rem;
   text-align: left;

   .module-wrap {
      margin-bottom: .4rem;

      &:nth-last-child(1) {
         margin-bottom: 0;
      }

      .wrap-title {
         margin-bottom: .213rem;
         text-align: left;
      }

      .module-card {
         border-radius: 5px;
         background: #FFF;
         padding: .213rem;
      }

      .ticketInfo {
         line-height: .8rem;


         .ticketInfo-row {
            display: flex;
            width: 100%;

            &.max-wrap {
               font-weight: bold;
               font-size: .48rem;
            }

            .classTime-wrap {
               min-width: 1.867rem;
            }

            .line-wrap,
            .custInfo-wrap {
               flex: 1;
            }

            .custInfo-wrap {
               display: flex;

               .custInfo {
                  flex: 1;
               }

               .seat-wrap {
                  min-width: 1.333rem;
                  position: relative;

                  .seatNo {
                     position: absolute;
                     right: .133rem;
                     bottom: 0;
                     padding: .053rem .187rem;
                     background: #ff9900;
                     color: white;
                  }
               }
            }
         }
      }

      &.changeMode-wrap {
         .tab-content {
            // padding: .267rem;

            text-align: center;

            .container {
               height: unset;
            }

            .van-radio-group {
               .node-radio {
                  margin-bottom: .267rem;
               }
            }
         }
      }
   }
}
</style>